import { render, staticRenderFns } from "./RbChart.vue?vue&type=template&id=2ce1ec48"
import script from "./RbChart.vue?vue&type=script&lang=js"
export * from "./RbChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports